import { Progress, Typography } from 'antd';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

import Utils from 'utils/utils';
import { useAppSelector, useTranslate } from 'hooks';

import { PrimaryMarketProjectInvestForm } from '../PrimaryMarketProjectInvestForm';

export const PrimaryMarketProjectInvest = () => {
	const { filledText, projectAlreadyFundedText, yourInvestmentProjectText } = useTranslate([
		'filledText',
		'projectAlreadyFundedText',
		'yourInvestmentProjectText',
	]);

	const project = useAppSelector((state) => state.primaryMarket.item);
	const percent = ((+project.investedAmount / +project.assignedAmount) * 100).toFixed(2);

	return project.possibleToInvest ? (
		<>
			<PrimaryMarketProjectInvestForm />
			<div className="primaryItem__cardInfo">
				<div className="primaryItem__progress">
					<Progress showInfo={false} percent={+percent} strokeColor="#65ABFF" />
					<div className="primaryItem__progressRow">
						<Typography.Text type="secondary">
							{percent}% {filledText}
						</Typography.Text>
						<Typography.Text type="secondary">
							<Trans
								i18nKey="leftText"
								values={{ money: Utils.moneyFormat(+project.availableToInvest) }}
							/>
						</Typography.Text>
					</div>
				</div>
			</div>
		</>
	) : (
		<div className="primaryItem__impossibleInvest">
			<Typography.Text>{projectAlreadyFundedText}</Typography.Text>

			<div className="primaryItem__impossibleProgress">
				<Progress showInfo={false} percent={100} strokeColor="#65ABFF" />
				<div className="primaryItem__progressRow">
					<Typography.Text type="secondary">100% {filledText}</Typography.Text>
				</div>
			</div>

			<div className="primaryItem__yourInvestment">
				<Typography.Text type="secondary">{yourInvestmentProjectText}:&nbsp;</Typography.Text>
				{Utils.moneyFormat(Number(project.amountOfInvestment))}
			</div>

			<Typography.Text className="primaryItem__link">
				<Trans
					i18nKey="viewAvailableProjectsText"
					components={{
						l: <Link to="/account/invest/primarymarket" />,
					}}
				/>
			</Typography.Text>
		</div>
	);
};
